const ASSETS_BASE_URL = 'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com';

const getAssetUrl = (asset: string) => {
  if (asset.startsWith('/')) {
    asset = asset.slice(1);
  }
  return `${ASSETS_BASE_URL}/${asset}`;
};

export const templateUtils = {
  getAssetUrl,
};
